
var Model = require("../types/Model.js");
var Set = require("es6-set");
var isObject = require("isobject");
var Promise = require("promise");
var xtend = require("xtend");

var MAX_AT_ONCE = 300;

/**
 * @module People
 * @description Keeps track of the state of arbitrary users.  Expects config
 * to be empty or undefined
 * @type {Model}
 */
module.exports = Model({
	name: "availability",

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	add: add,
	listen_users: listen_users,
	fetch_user_data: fetch_user_data,

	_users: null
});

/**
 * Sets up the mqtt listeners array and pushes an empty object as the state
 * @return {[type]} [description]
 */
function init() {
	this._users = new Set();
	this.push({});
}

function triggers() {
	return {
		"add": add
	};
}

function listeners() {
	return {
		"connectivity:online": refresh_all,
		"connectivity:offline": offline_all
	};
}

/**
 * Clears private cached state
 */
function uninit() {
	this._users = null;
}

/**
 * Refreshes the status of all users being tracked
 */
function refresh_all() {
	var who = set_to_array(this._users);
	this.fetch_user_data(who);
}

/**
 * Starts tracking the state of another user/users
 * @param {Array|String} who Either an id or an array of ids to start tracking
 */
function add(who) {
	if (isObject(who)) who = who.who; // Handle for event case

	var users = this._users; // Get a reference to the set of all current users

	who = [].concat(who); // Convert to array if it isn't already

	who = who.filter(not(users.has.bind(users))); // Filter out any users that have allready been added

	if (who.length) {
		who.forEach(users.add.bind(users)); // Add any new users to the set
		this.listen_users(who);
		return this.fetch_user_data(who);
	} else this.extend({});
}

/**
 * Listens for changes in users' settings.
 * @param  {Array} users Array of user ids to listen to
 */
function listen_users(users) {
	users.map(listen_user.bind(this));
}

/**
 * Listens for changes in a user's settings
 * @param  {String} who Id of the user to listen to
 */
function listen_user(who) {
	var event = "mqtt:u/" + who + "/status/available";

	this.tracker.on(event, handle_status_change.bind(this, who));
}

function handle_status_change(who, data) {
	var status = data.status;
	var previousStatus = this.data[who];
	var newValue = 1; // A person is either a valid status or defaults to online.

	// if set newValue
	if (status === true || status === 1) {
		newValue = 1;
	} else if (!status) {
		newValue = 0;
	} else newValue = status;

	// Don't spam when things boot up
	if (previousStatus === newValue) return;

	var extender = {};
	extender[who] = newValue;
	this.extend(extender);
}

/**
 * Sets all users to be offline, used when losing connection
 */
function offline_all() {
	this.push({});
}

/**
 * Fetches the data for a given set of users and updates the state
 * @param  {Array} who Array of user ids to fetch
 * @return {Promise}     Resolves when the state has been updated
 */
function fetch_user_data(who) {
	this.emit("loading:trigger:start");
	var chunks = [];
	var total = who.length;
	var group = 0;
	while(group < total) {
		chunks.push(who.slice(group, group + MAX_AT_ONCE));
		group += MAX_AT_ONCE;
	}

	return Promise.all(chunks.map(function(chunk){
		if(!chunk.length) return [];
		return this.api.people.statuses(chunk);
	}, this))
		.then(flatten)
		.then(this.extend.bind(this))
		.catch(console.error.bind(console))
		.then(finish_loading.bind(this));
}

function finish_loading() {
	this.emit("loading:trigger:finish");
}

// Inverts a function
function not(fn) {
	return function () {
		return !(fn.apply(this, arguments));
	};
}

// Converts a set to an array
function set_to_array(set) {
	var result = [];
	set.forEach(function (item) {
		result.push(item);
	});
	return result;
}

function flatten(list) {
	return list.reduce(function(a, b){return xtend(a, b);}, {});
}